import { NumberField, useRecordContext } from "react-admin";
import { hmLightTheme } from "../themes/hmTheme";

const CustomAmountField = ({ ...props }) => {
  const record = useRecordContext();
  if (!record) return null;
  return (
    <NumberField
      {...props}
      options={{
        style: "currency",
        currency: "USD",
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 2,
      }}
      sx={{
        fontFamily: hmLightTheme?.palette?.numberFontFamily,
        textAlign: "right",
        display: "inline-block",
        width: "100%",
        verticalAlign: "middle",
        alignItems: "center",
      }}
    />
  );
};

export default CustomAmountField;
